<template>
  <div>
    <v-card flat>
      <v-card-title class="primary--text"
        ><v-btn @click="back" class="ml-n5 primary--text" text>
          <v-icon>mdi-reply</v-icon></v-btn
        >Contact us</v-card-title
      >

      <v-card-text>
        <form>
          <v-row>
            <v-col cols="4"> </v-col>
            <v-col cols="4">
              <sequential-entrance fromTop animation="bounceIn" delay="1000">
                <v-text-field
                  v-model="rowlist.user_name"
                  outlined
                  label="First Name"
                  required
                  dense
                ></v-text-field>
              </sequential-entrance>
            </v-col>
            <v-col cols="4"> </v-col>
          </v-row>

          <v-row>
            <v-col cols="4"> </v-col>
            <v-col cols="4">
              <sequential-entrance fromTop>
                <v-text-field
                  v-model="rowlist.email"
                  outlined
                  label="Email"
                  required
                  dense
                ></v-text-field>
              </sequential-entrance>
            </v-col>
            <v-col cols="4"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> </v-col>
            <v-col cols="4">
              <sequential-entrance fromTop>
                <v-text-field
                  v-model="rowlist.mobile_num"
                  outlined
                  label="Contact No."
                  required
                  dense
                ></v-text-field>
              </sequential-entrance>
            </v-col>
            <v-col cols="4"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> </v-col>
            <v-col cols="4">
              <sequential-entrance fromTop>
                <v-textarea
                  label="Tell Us More About Your Requirement"
                  auto-grow
                  outlined
                  rows="3"
                  row-height="30"
                  v-model="reason"
                ></v-textarea>
              </sequential-entrance>
            </v-col>
            <v-col cols="4"> </v-col>
          </v-row>
        </form>
      </v-card-text>

      <div class="text-center ma-2">
        <sequential-entrance fromTop>
          <v-btn
            depressed
            class="text-center mt-n2 mb-2 mr-3"
            color="primary"
            @click="backtorequest()"
            >BACK</v-btn
          >
        </sequential-entrance>
        <sequential-entrance fromTop>
          <v-btn
            depressed
            class="text-center mt-n2 mb-2"
            color="primary"
            @click="SendRequest()"
            >Send Request</v-btn
          >
        </sequential-entrance>
      </div>
    </v-card>
  </div>
</template>
<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  data: () => ({
    rowlist: {},
    reason: "",
  }),
  created() {
    this.getuserdeatils();
  },
  methods: {
    backtorequest() {
      this.$router.push("/Dashboard");
    },
    async getuserdeatils() {
      // alert(20);
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CORPLOGIN",
          email_id: this.$store.getters.get_useremail,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.rowlist = responseData.data.data;
          // console.log("rowlist",this.rowlist)
        }
      }
    },
    back() {
      this.$router.push("/Dashboard");
    },
    async SendRequest() {
      // alert(20);
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CONTACT",
          fullname: this.rowlist.user_name,
          mobile_number: this.rowlist.mobile_num,
          reason: this.reason,
          email_id: this.rowlist.email,
          user_id: this.$store.getters.get_userid,
        },
      };
      var responseData = await apiCall(inputData);
      this.$store.commit("snackbar/showMessage", {
        content: responseData.data.data,
        color: "green",
      });

      this.reason = "";
      this.$router.push("/Dashboard");

      // if (responseData.data.status == "00") {
      //   this.request = responseData.data.data;
      //   console.log("request",this.request)
      // }
    },
  },
};
</script>
